import React from "react";
import RegisterHeader from "./Common/Header";
import Typography from "@mui/material/Typography";
import { Box, Container, Paper, Chip, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmailIcon from "@mui/icons-material/Email";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";


import "./Confirmation.scss";
import Footer from "../Footer";
// import { useRegister } from "../../context/RegisterContext";
// import { useNavigate } from "react-router-dom";

const RegisterConfirmation = () => {
  // const navigate = useNavigate();
  // const { canProceed } = useRegister();

  // useEffect(() => {
  //   if (!canProceed()) {
  //     navigate("/parceiros");
  //     return;
  //   }
  // }, []);

  return (
    <div className="Register">
      <RegisterHeader />

      <Container maxWidth="md" className="MainContainer">
        {/* Seção de Sucesso */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "40px",
            marginBottom: "30px",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 80,
              color: "#4caf50",
              marginBottom: "16px",
              filter: "drop-shadow(0 4px 8px rgba(76, 175, 80, 0.3))",
            }}
          />
          
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              fontSize: "28px",
              textAlign: "center",
              color: "#2e7d32",
              marginBottom: "12px",
              background: "linear-gradient(135deg, #4caf50, #2e7d32)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            🎉 Cadastro Aprovado!
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              textAlign: "center",
              color: "#2e7d32",
              lineHeight: 1.6,
              marginBottom: "24px",
              maxWidth: "600px",
            }}
          >
            Parabéns! Seu cadastro foi aprovado e você já tem acesso ao painel Washpass.
          </Typography>

          {/* Botão para acessar o painel */}
          <Button
            variant="contained"
            size="large"
            endIcon={<OpenInNewIcon />}
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              fontWeight: 600,
              fontSize: "16px",
              padding: "12px 32px",
              borderRadius: "12px",
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
              marginBottom: "24px",
              "&:hover": {
                backgroundColor: "#1565c0",
                boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                transform: "translateY(-2px)",
              },
              transition: "all 0.2s ease-in-out",
            }}
            onClick={() => {
              // Aqui você pode adicionar a lógica para redirecionar para o painel
              window.open("https://parceiro.wash.app.br/login", "_blank");
            }}
          >
            Acesse seu painel e assine o seu contrato!
          </Button>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap", marginBottom: "20px" }}>
            <Chip
              icon={<EmailIcon />}
              label="Contrato enviado"
              sx={{ 
                fontWeight: 500,
                color: "#4caf50",
                borderColor: "#4caf50",
                "&:hover": {
                  backgroundColor: "rgba(76, 175, 80, 0.1)"
                }
              }}
              variant="outlined"
            />
            <Chip
              icon={<DashboardIcon />}
              label="Acesso liberado"
              sx={{ 
                fontWeight: 500,
                color: "#4caf50",
                borderColor: "#4caf50",
                "&:hover": {
                  backgroundColor: "rgba(76, 175, 80, 0.1)"
                }
              }}
              variant="outlined"
            />
          </Box>
        </Box>

        {/* Seção das Etapas */}
        <Paper
          elevation={0}
          sx={{
            padding: "30px 20px",
            borderRadius: "20px",
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            marginBottom: "20px",
          }}
        >

          {/* Timeline das Etapas */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            {/* Etapa 1 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                padding: "16px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 100%)",
                border: "1px solid #b3c6ff",
              }}
            >
              <CheckCircleIcon sx={{ color: "#1e88e5", fontSize: 32 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#46558C", marginBottom: "4px" }}>
                  Cadastro Enviado
                </Typography>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  Seus dados foram enviados com sucesso
                </Typography>
              </Box>
            </Box>

            {/* Etapa 2 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                padding: "16px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 100%)",
                border: "1px solid #b3c6ff",
              }}
            >
              <CheckCircleIcon sx={{ color: "#1e88e5", fontSize: 32 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#46558C", marginBottom: "4px" }}>
                  Cadastro Aprovado
                </Typography>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  Análise concluída e aprovada pela equipe
                </Typography>
              </Box>
            </Box>

            {/* Etapa 3 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                padding: "16px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 100%)",
                border: "1px solid #b3c6ff",
              }}
            >
              <AssignmentIcon sx={{ color: "#1e88e5", fontSize: 32 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#46558C", marginBottom: "4px" }}>
                  Contrato Enviado
                </Typography>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  Documento enviado para seu e-mail
                </Typography>
              </Box>
            </Box>

            {/* Etapa 4 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                padding: "16px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 100%)",
                border: "1px solid #b3c6ff",
              }}
            >
              <DashboardIcon sx={{ color: "#1e88e5", fontSize: 32 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#46558C", marginBottom: "4px" }}>
                  Acesso ao Washpass
                </Typography>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  Painel liberado e pronto para uso
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>

      <Footer />
    </div>
  );
};

export default RegisterConfirmation;
